/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.4.0
 */

import { ClearWhite, FreshAsphalt, FreshAsphalt50, Green, SpbSky0, SpbSky1, SpbSky2 } from './palette';

// Title panel

export const tariffsAndServicesTitlePanelBgColor = SpbSky1;

// Cards

export const tariffCard2025MoreButton = Green;
export const tariffsCard2025TitleBackground = SpbSky0;
export const tariffsAndServicesCardBgColor = ClearWhite;
export const tariffsAndServicesCardBorderColorNormal = 'transparent';
export const tariffsAndServicesCardBorderColorHover = SpbSky2;
export const tariffsAndServicesCardBorderColorSelected = Green;
export const tariffsAndServicesCardColor = FreshAsphalt;
export const tariffsAndServicesCardCostColor = FreshAsphalt50;

// Accordion

export const tariffsAndServicesSideBordersColor = SpbSky1;
export const tariffsAndServicesSideBgColorHover = SpbSky0;
export const tariffsAndServicesSideLeftBorderColorHover = Green;
export const tariffsAndServicesSideLevel1BgColorActive = Green;
export const tariffsAndServicesSideLevel1ColorActive = ClearWhite;

// Filter

export const tariffsAndServicesFilterButtonBgColor = ClearWhite;
export const tariffsAndServicesFilterButtonBorderColor = ClearWhite;
export const tariffsAndServicesFilterItemBgColorHover = Green;
export const tariffsAndServicesFilterItemColorHover = ClearWhite;
